import React, { useState } from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { PutMethod } from "../../helper/Api";
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';

const OneMinuteTimer = () => {
    const minuteSeconds = 120;
    const [stop, setStop] = useState(false);
    const { token } = useSelector((item) => item.user);

    // تابعی برای به‌روزرسانی زمان هر ثانیه
    const renderTime = ({ remainingTime }) => {
        if (remainingTime === 0) {
            setStop(false)
            // زمان به پایان رسیده است
            return <div className='text-[10px] flex w-[100%] text-center'>زمان به پایان رسید.</div>;
        }
        setStop(true)
        // محاسبه دقایق و ثانیه‌ها
        const seconds = remainingTime % 60;
        const minutes = Math.floor(remainingTime / 60);

        // نمایش دقایق و ثانیه‌ها
        return (
            <div>
                <div>{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</div>
            </div>
        );
    };


    const ReceiveSms = async (e) => {
        //refresh nashodn site bade click
        e.preventDefault();

        var url = `/api/user/login/send/sms`;

        PutMethod(
            { url: url, token: token },
            (res) => {
                if (res.status === "success") {
                    toast.success("رمز یک بار مصرف ارسال شد");
                    setStop(true)
                }
            },
            (error) => {
                toast.error(error.response.data.msg);
            }
        );
    };

    return (
        <>

            {stop ? (
                <CountdownCircleTimer
                    colors="#A30000"
                    isPlaying // فعال بودن تایمر
                    duration={minuteSeconds} // زمان محاسبه شده بر حسب ثانیه
                    // colors={[['#004777', 0.33], ['#F7B801', 0.33], ['#A30000']]} // رنگ‌های مورد استفاده در دایره
                    size={52} // اندازه دایره
                    strokeWidth={2} // عرض خطوط دایره
                    strokeLinecap="round" // شکل انتهای خطوط دایره
                    trailColor="#E5E5E5" // رنگ پس زمینه خطوط دایره
                >
                    {renderTime}
                </CountdownCircleTimer>

            ) :


                <div onClick={(e) => ReceiveSms(e)}>

                    <CountdownCircleTimer
                        // onComplete={() => texts()}
                        colors="#A30000"
                        isPlaying={false} // فعال بودن تایمر
                        // colors={[['#004777', 0.33], ['#F7B801', 0.33], ['#A30000']]} // رنگ‌های مورد استفاده در دایره
                        size={52} // اندازه دایره
                        strokeWidth={2} // عرض خطوط دایره
                        strokeLinecap="round" // شکل انتهای خطوط دایره
                        trailColor="#E5E5E5" // رنگ پس زمینه خطوط دایره
                    >
                        {({ remainingTime }) => <span className='flex items-center text-[8px] text-bold'>دریافت پیام</span>}
                    </CountdownCircleTimer>
                </div>

            }


        </>

    );
};

export default OneMinuteTimer;